
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const neveRMX16: IProductData = {
  id: "neve-rmx16-500",
  name: "AMS 500 Series FX Unit",
  description: "The world’s first microprocessor-controlled, full-bandwidth digital reverberator has characterised an enormous number of seminal recordings from the 1980s onwards – now it’s been adapted for 500 series format.",
  specialOrder: true,
  images: ["/img/neve_rmx16_front.jpg"],
  details: [{
    label: "Description",
    markdown: `
The RMX16 uses the same bit-for-bit algorithms from the original 1982 unit – resulting in pure 1980’s FX.

The high contrast OLED display makes setting parameters and navigating through programs simple and intuitive, with no complex menus to get in the way of your creativity.

The modern, high-performance 32-bit DSP combined with 24-bit, 48KHz sampling through premium AD/DA converters produces over 100dB of dynamic range with 22dB of headroom. In addition, this transparent platform has the resolution necessary to model the original RMX16’s digital performance perfectly.

From the famous Non-Lin reverb program through to the widely utilized Ambience, the nine original programs are available to choose from. However, the RMX 16 500 doesn’t stop there; 9 additional rare aftermarket algorithms, totalling 18 unique programs, are included to blend into your productions and shape your music.

The original RMX16 was an ‘all-or-nothing approach’, with the output thoroughly ‘wet’ with reverb FX. A wet/dry mix blend function is added so that the unit can be added as an insert when tracking or mixing to bring the RMX16 500 up-to-date.

The RMX 16 500 wouldn’t be complete without the classic calculator-style keypad; this isn’t only used to precisely define decay, pre-delay times, or filter levels, it can also program user-defined presets via the save/load feature.

The endless rotary pot encoder is an exciting addition; this is used to search through programs, navigate the presets, or program any parameter manually by dialling in settings while listening to the results in real-time.

The input and output responses were modelled from the original RMX16 to produce the same sonic performance here in the RMX16 500 I/O stages. In addition, the input and output levels are digitally controlled from 0 to 100% for precision gain staging through the unit to improve accuracy.

One hundred user-defined preset locations are accessible through the simple-to-use save/load feature. Create your sounds using the original programs as an ideal starting point.
`
    }, {
      label: "Specifications",
      markdown: `
• High-performance 32-bit DSP processing and 24-bit, 48KHz sampling with premium A/D and D/A converters.
• Over 100dB dynamic range with +22dBu of headroom.
• Adjustable input and output levels for optimum signal to noise performance.
• Low power consumption (and therefore cool running).
• Independent control of each program’s fundamental reverberant parameters.
• Nudge Buttons to increment or decrement data for all selectable reverberation functions.
• Alphanumeric program descriptions for ease of use when storing or recalling information for the unit’s memory.
• New rotary push encoder enabling all parameters and settings to be adjusted by ear.
• New wet/dry mix blend function.
• New save/recall feature with 100 user-defined memory slots.
• Heat Dissipation <7 watts
• Voltage +/-16V
• Current Amps RMS +/-16V 0.2A (MAX)
• Compatible 500-series rack/enclosure with Power Supply and line-level input/output connectors required, not supplied.
`
}, {
    label: "Audio Performance",
    markdown: `
• Headroom – >+22dBu @ 1kHz (<0.5% THD+N)
• Dynamic Range – 112dB @ 24dBu
• Signal to Noise Ratio – 82dBu 20Hz – 20kHz +4dB
• Frequency Response – Typically +/- 0.25dB, 20Hz to 18kHz
• Distortion (THD+N) – Typically 0.002% @ 1kHz (measured at +20dBu, 10Hz to 20kHz filter)
• General Noise – <-75dBu (20Hz to 20kHz filter)
• Line Inputs – Input Impedance ≈20KΩ electronically balanced in slot 1
• Line Outputs – Output Impedance ≈150Ω electronically balanced: (L) Slot 1 (R) Slot 3
`
  }, {
    label: "Dimensions",
    markdown: `
• Height – 133.4 mm(5.25 inches)
• Width – 114.3mm (4.5 inches)
• Depth – 145mm (5.7 inches)
• Weight – 0.84kg (1.85 inches)
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.ams-neve.com/outboard/500-series-range/ams-rmx16/" target="_blank">https://www.ams-neve.com/outboard/500-series-range/ams-rmx16/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.FX, HASHTAGS.RECORDING, HASHTAGS.LIVE_SOUND, HASHTAGS.THREE_U, HASHTAGS.API_500],
    manufacturer: BRAND.NEVE,
  },
  videos: []
}